import { IconNames } from '@blueprintjs/icons';
import { Button } from '@strata/react-buttons';
import { Dialog } from '@strata/react-dialog';
import { SuccessToast } from '@strata/react-toast-message';
import PropTypes from 'prop-types';

import { handleError } from 'services/Error';
import { useSetPreferredPharmacyOfferMutation } from 'store/api/goLiveApi';

const Title = 'Set Default Expiration';

export const DefaultReferralExpirationDialog = ({
    isOpen,
    treatmentsCount,
    preferredPharmacyOffer = undefined,
    onClose,
}) => {
    const [setPreferredPharmacyOffer] = useSetPreferredPharmacyOfferMutation();
    const treatmentsCountVerbiage =
        treatmentsCount === 1
            ? `this grandfathered treatment`
            : `these ${treatmentsCount} grandfathered treatments`;

    return (
        <Dialog
            isOpen={isOpen}
            dialogTitle={Title}
            headerIcon={IconNames.WARNING_SIGN}
            onSecondaryButtonClick={() => {
                onClose(false);
            }}
            onPrimaryButtonClick={async () => {
                try {
                    await setPreferredPharmacyOffer(preferredPharmacyOffer).unwrap();
                    SuccessToast({ message: 'Preferred pharmacy offer set successfully.' });
                    onClose(true);
                } catch (error) {
                    handleError(
                        error,
                        'An error occurred setting preferred pharmacy offer. Please try again.',
                    );
                }
            }}
            primaryButtonLabel="Yes, Set Default Expiration"
            primaryButtonIntent={Button.Intent.DANGER}
            secondaryButtonLabel="Cancel"
            dialogContent={
                <div className="padding__bottom--medium">
                    Are you sure you want to set default expiration dates (365 days) on
                    {` ${treatmentsCountVerbiage}?`}
                </div>
            }
        />
    );
};

DefaultReferralExpirationDialog.Title = Title;

DefaultReferralExpirationDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    treatmentsCount: PropTypes.number.isRequired,
    preferredPharmacyOffer: PropTypes.shape({
        treatmentId: PropTypes.string,
        searchText: PropTypes.string,
        goLiveDate: PropTypes.arrayOf(PropTypes.string),
        productServiceOid: PropTypes.arrayOf(PropTypes.string),
        segmentId: PropTypes.arrayOf(PropTypes.string),
        incumbentSupplier: PropTypes.arrayOf(PropTypes.string),
        productType: PropTypes.arrayOf(PropTypes.string),
        isLDD: PropTypes.arrayOf(PropTypes.bool),
        hasIssues: PropTypes.arrayOf(PropTypes.string),
        releaseStatus: PropTypes.arrayOf(PropTypes.string),
        upcomingTreatmentBatchName: PropTypes.arrayOf(PropTypes.string),
        preferredPharmacyOffer: PropTypes.arrayOf(PropTypes.string),
        therapeuticCategory: PropTypes.arrayOf(PropTypes.string),
        supplierNpi: PropTypes.string,
        transitionSupplier: PropTypes.string,
        referentPriceType: PropTypes.string,
        offerRate: PropTypes.number,
        grandfathered: PropTypes.bool,
        referralExpirationStrategy: PropTypes.string,
        referralExpirationReferenceDate: PropTypes.string,
        expireInSetsOf: PropTypes.number,
        priceIsFrozen: PropTypes.bool,
        routeCode: PropTypes.string,
        useContractRate: PropTypes.bool,
        forceTransferRoute: PropTypes.bool,
    }),
    onClose: PropTypes.func.isRequired,
};
